/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteDiscountRequest = {
  /**
   * The unique identifier of the discount to delete
   */
  id: string;
};

/** @internal */
export const DeleteDiscountRequest$inboundSchema: z.ZodType<
  DeleteDiscountRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
});
/** @internal */
export type DeleteDiscountRequest$Outbound = {
  id: string;
};

/** @internal */
export const DeleteDiscountRequest$outboundSchema: z.ZodType<
  DeleteDiscountRequest$Outbound,
  z.ZodTypeDef,
  DeleteDiscountRequest
> = z.object({
  id: z.string(),
});

export function deleteDiscountRequestToJSON(
  deleteDiscountRequest: DeleteDiscountRequest,
): string {
  return JSON.stringify(
    DeleteDiscountRequest$outboundSchema.parse(deleteDiscountRequest),
  );
}
export function deleteDiscountRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteDiscountRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteDiscountRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteDiscountRequest' from JSON`,
  );
}
